module.exports = __webpack_public_path__ + "img/img46.34162d5a.png";